export default "__VITE_ASSET__CO33u1Jr__"